import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

export default {
  getters: {
    [getterTypes.GET_MEMBER]: state => state.member,
    [getterTypes.GET_MEMBER_LOCAL_STORAGE_KEY]: state => state.localStorageKey,
  },
  actions: {
    async [actionTypes.DO_CREATE_MEMBER]({ commit }, payload) {
      const { data } = await HTTP.post('/members', payload);
      commit(mutationTypes.SET_MEMBER, data.data.members[0]);
      return data;
    },
    async [actionTypes.DO_GET_MEMBER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/members/${id}`, { params });
      commit(mutationTypes.SET_MEMBER, data.data.members[0]);
      return data;
    },
    async [actionTypes.DO_UPDATE_MEMBER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/members/${id}`, params);
      commit(mutationTypes.SET_MEMBER, data.data.members[0]);
      return data;
    },
  },
  mutations: {
    [mutationTypes.SET_MEMBER](state, member) {
      localStorage.setItem(state.localStorageKey, JSON.stringify(member));
      state.member = member;
    },
    [mutationTypes.UNSET_MEMBER](state) {
      localStorage.removeItem(state.localStorageKey);
      state.member = {};
    },
  },
  state: {
    member: {},
    localStorageKey: 'member',
  },
};
